import { ErrorInfo } from "../types";

type ErrorCauseProps = {
  errorInfo: ErrorInfo;
};

export function ErrorCause({ errorInfo }: ErrorCauseProps) {
  const cause = errorInfo.devDetails.cause;

  if (!cause) {
    return null;
  }

  return (
    <div>
      <h4 className="mb-2 font-semibold text-red-800">Cause:</h4>
      <div className="rounded bg-white p-3 font-mono text-sm text-amber-700">
        {cause}
      </div>
    </div>
  );
}
